<template>
    <div class="d-flex mt-1 mx-5" style="font-size: 16px;">
        <span class="p-1">{{label_true}}</span>
        <b-form-checkbox  
            switch     
            class="toggle-top" 
            v-model="status"
            @change="value => $emit('change', value)" />
        <div class="p-1">{{label_false}}</div>
    </div>
</template>

<script>
export default {
    name:'graph-switch',
    props: ['label_true', 'label_false', 'value'],
    data(){
        return {'status':this.value}
    }
}
</script>

<style lang="scss" scoped>
.toggle-top{
    margin-left: 0.2rem;
    margin-top: -2.5rem;
}
</style>